<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-0">
    <v-expansion-panel-header
      id="rec_pub_recs_req"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >Program Features
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <v-card shaped class="mt-4">
        <v-card-title>
          <h4>Program Features</h4>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 1.1rem !important;">
        
            <ul class="mt-2">
              <li>Provide an overhead view to support officers on the ground.</li>
              <li>Respond and assist Fire Department personnel.</li>
              <li>Safely assess building interiors, exteriors and hazardous areas.</li>
              <li>Document crime scenes and major traffic collisions.</li>
              <li>Assist in search and rescue operations.</li>
            </ul>
            <p>
            The Reno Police Department has integrated drone technology as a practical tool to enhance operational effectiveness for our community. The program only operates under strict adherence to federal air regulations, Nevada revised statutes, city ordinance, and department policies. The pilots operating the equipment are constantly communicating with the Federal Aviation Administration (FAA) to obtain necessary authorization to operate department drones within the airspace above our city.
            By continuing to adopt evolving technology, the Reno Police Department
            remains committed to serving the community and 
            their public safety needs efficiently, effectively, and professionally.
            </p>
          </div>
        
        </v-card-text>
      </v-card>

    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
border-img {
  border: 1px solid black;
}
.div-login-page-img {
  margin: 0;
}
.letter_img {
  width: 100%;
  margin-left: 0 !important;
}
.login-page-img {
  width: 100%;
  margin-left: 0 !important;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter_img {
    max-width: 436px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "content1",
  mixins: [bus_common],
  data: function () {
    return {
      isActive1: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
